class DeliveryNoticePopup extends HTMLElement {
  constructor() {
    super();
    this.closeButtons = this.querySelectorAll('[data-close]');
    this.dismissalCookie = 'at_delivery_notice_dismissed';
  }

  connectedCallback() {
    if (this.isDismissed()) return;

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => this.dismiss());
    });

    this.shouldShow().then((shouldShow) => {
      if (shouldShow) this.hidden = false;
    });
  }

  isDismissed() {
    return document.cookie
      .split('; ')
      .some((cookie) => cookie === `${this.dismissalCookie}=1`);
  }

  async shouldShow() {
    if (this.dataset.isAustrianMarket === 'true') return true;

    try {
      const response = await fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`);
      if (!response.ok) return false;

      const result = await response.json();
      return result.detected_values?.country?.handle === 'AT';
    } catch (error) {
      return false;
    }
  }

  dismiss() {
    const days = Number.parseInt(this.dataset.dismissalDays, 10) || 30;
    const maxAge = days * 24 * 60 * 60;

    document.cookie = `${this.dismissalCookie}=1; Max-Age=${maxAge}; Path=/; SameSite=Lax; Secure`;
    this.hidden = true;
  }
}

if (!customElements.get('delivery-notice-popup')) {
  customElements.define('delivery-notice-popup', DeliveryNoticePopup);
}
